<template>
  <section class="content">
    <template v-if="notFound">
      <div class="error-page">
        <h2 class="headline text-danger"> 404</h2>
        <div class="error-content">
          <h3><i class="fa fa-warning text-danger"></i> Oops! Order not found.</h3>
          <p>
            We could not find the order you were looking for.
            Meanwhile, you may <a href="/home">return to dashboard</a> or try using the search form.
          </p>
          <form @submit.prevent="$router.push(`/orders/${goto}`)" class="search-form">
            <div class="input-group">
              <input type="text" name="search" class="form-control" :placeholder="'goto_order' | translate" v-model="goto">
              <div class="input-group-btn">
                <button type="submit" name="submit" class="btn btn-danger"><i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
          <br>
          <form @submit.prevent="goToMp()" class="search-form">
            <div class="input-group">
              <input type="text" name="search" class="form-control" placeholder="zu MP ID springen" v-model="gotoMP">
              <div class="input-group-btn">
                <button type="submit" name="submit" class="btn btn-danger"><i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <order-history :transitions="selectedLine.transitions" :name="'historyModal'" :main="false"></order-history>
        <order-history :transitions="order.transitions" :name="'orderHistoryModal'" :main="true"></order-history>
        <order-history-with-comments :transitions="lineTransitions" :main="false" :name="'orderHistoryWithComments'"></order-history-with-comments>
        <cancel-modal @action="cancelOrder($event)" :externalOrder="order.merchant_external_order"></cancel-modal>
        <return-modal @action="sendReturn($event)"></return-modal>
        <refund-modal @action="sendRefund($event)" @alert="alertError($event)"></refund-modal>
        <support-modal></support-modal>
        <div class="modal fade" id="label-history" tabindex="-1" role="dialog" aria-labelledby="item-history_ModalLabel" style="display: none;">
          <div class="modal-dialog modal-labels" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><i class="fa fa-truck mr-5"></i>{{'label_history' | translate}}</h4>
              </div>
              <div class="modal-body">
                <label-history :transitions="selectedLabelTransitions" :shipping="selectedShipping" :returnCode="selectedReturn"></label-history>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">{{'order_details' | translate}} <small>QB-ID: {{order.id}}</small></h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="box-controls">
              <div class="alert alert-danger mt-10 mb-10" v-if="order && order.status.label === 'mp_cancellation'" >
                <h4><i class="icon fa fa-warning"></i>Achtung - Diese Bestellung wurde von zalando storniert!</h4>
                <p>Bitte aktualisieren Sie den Bestand für diese Artikel in Ihrer Warenwirtschaft.</p>
              </div>
              <div class="alert alert-warning mt-10 mb-10" v-if="order && order.status.label === 'reserved' " >
                <h4><i class="icon fa fa-warning"></i>Achtung - Diese Bestellung ist noch nicht freigegeben!</h4>
                <p>Sie können Ihre Versandpapiere erst nach Freigabe erstellen.</p>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <h4>
                    {{'delivery_address' | translate}}
                  </h4>
                  <hr>
                  <template v-if="order.customer && order.customer !== null">
                    <h5>{{order.customer.corrected_first_name !== ''? order.customer.corrected_first_name : order.customer.delivery_first_name}} {{order.customer.corrected_last_name !== ''? order.customer.corrected_last_name : order.customer.delivery_last_name}}</h5>
                    <p v-if="order.customer.corrected_street === ''">{{order.customer.delivery_address_line_1}}<br>
                      <span v-html="this.getObjectData(order.customer.delivery_address_line_2)"></span>
                      <br>{{order.customer.delivery_zip_code}} {{order.customer.delivery_city}}<br>{{order.customer.delivery_country | country}}
                      <span v-if="validDeliveryCountries.includes(order.customer.delivery_country)"><img class="img-responsive img-channel" :src="`/static/img/country_${order.customer.delivery_country}.svg`"></span>
                    </p>
                    <p v-else>
                      {{order.customer.corrected_street}} {{order.customer.corrected_street_number}} <br>
                      {{order.customer.corrected_zip}} {{order.customer.corrected_city}}
                    </p>
                    <p class="small text-muted">
                      <template v-if="order.customer.email">
                        <i class="fa fa-envelope mr-5"></i> <a :href="`mailto:${order.customer.email}`">{{order.customer.email}}</a>
                        <br>
                      </template>
                      <template v-if="order.customer.phone_number">
                        <i class="fa fa-phone mr-5"></i> <a :href="`tel:${order.customer.phone_number}`">{{order.customer.phone_number}}</a>
                        <br>
                      </template>
                    </p>
                  </template>
                  <template v-else>
                    <span class="text-warning"><i class="fa fa-info-circle mr-5"></i><strong>{{'address_message' | translate}}</strong></span>
                  </template>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <ul class="list-group list-group-unbordered">
                    <li class="list-group-item"><b>{{'order_number' | translate}}: </b>{{order.ext_order_id}}</li>
                    <li class="list-group-item"><b>{{'order_number_addition' | translate}}: </b>{{order.ext_order_id_addition}}</li>
                    <li class="list-group-item"><b>{{'order_date' | translate}}: </b>{{order.order_date | orderDate}} <small class="text-muted">{{order.order_date | orderDate(true)}}</small></li>
                    <li class="list-group-item"><b>{{'order_total' | translate}}: </b>{{order.order_total | currency}}</li>
                    <li class="list-group-item"><b>{{'sales_channel' | translate}}: </b><i :class="getIcon(order.sales_channel)"></i> {{order.sales_channel | translate}}</li>
                    <li class="list-group-item"><b>Rating {{'points' | translate}}: </b>{{order.points}}</li>
                  </ul>
                </div>
              </div>
              <div class="row" v-if="order && order.customer_comment !== ''">
                <div class="attachment-block clearfix">
                  <p>
                    <strong>
                      <i class="fa fa-comment mr-5"></i>{{'customer_comment' | translate}}
                    </strong>
                  </p>
                  <p class="small mb-10">{{order.customer_comment}}</p>
                </div>
              </div>
              <template v-if="order.shippings">
                <hr  v-if="order.shippings.length > 0 && isDirectListing === 1"/>
                <div class="row" v-if="order.shippings.length > 0 && isDirectListing === 1">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label class=" control-label no-margin">
                      <i class="fa fa-amazon mr-5"></i>Amazon Rechnung erstellen<br>
                      <small class="text-info"><i class="fa fa-info-circle mr-5"></i>Erzeugen Sie hier eine Rechnung für Ihre Amazon Direktverkäufe.</small>
                    </label>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" >
                    <button data-toggle="modal" data-target="#createInvoice" data-title="Rechnung erstellen" data-original-title="Rechnung erstellen" title="" class="btn btn-sm btn-info"  v-if="invoicePath === ''">
                      Rechnung erstellen <i class="fa fa-edit ml-5"></i>
                    </button>
                    <a v-else :href="invoicePath" target="_blank" class="btn btn-default btn-info">Rechnung herunterladen<i class="fa fa-cloud-download ml-5"></i></a>
                  </div>
                </div>
              </template>
              <hr />
              <div :class="erpDisabled ? 'hidden row' : 'row'">
                <div class="form-group">
                  <label class="col-lg-6 col-md-6 col-sm-6 col-xs-12 control-label">Bestellung erneut an die Warenwirtschaft übermitteln.<br><small class="text-muted"><i class="fa fa-warning mr-5"></i>{{'erp_export' | translate}}</small></label>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <button :disabled="erpDisabledBtn" data-toggle="tooltip" @click="erpExport()" :data-title="'erp_export' | translate" data-original-title="" title="" class="btn btn-warning"><i class="fa fa-share mr-5"></i>ERP Export</button>
                    <button type="button" data-toggle="modal" data-target="#orderHistoryModal" class="btn btn-sm btn-default pull-right"><i class="fa fa-clock-o mr-5"></i>{{'order' | translate}} {{'history' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-body" :key="orderKey">
              <template v-if="order.lines && order.lines.length > 0" v-for="(line, index) in order.lines">
                <div class="row" :key="line.id">
                  <div class="col-xs-12 mb-10">
                    <span :class="line.status.style"><i :class="line.status.icon"></i>{{line.status.label | translate}}</span>
                    <span class="mr-5 text-muted pull-right"><strong>#{{index+1}}</strong></span>
                    <small class="text-success ml-5">
                      <span class="fa fa-info-circle mr-5"></span>{{'booked_from' | translate}}: {{`${filterStore(line.booked_store_id).name} - ${filterStore(line.booked_store_id).street} ${filterStore(line.booked_store_id).street_no} - ${filterStore(line.booked_store_id).zip_code} ${filterStore(line.booked_store_id).city}`}}
                    </small>
                  </div>
                  <div id="item-1">
                    <div class="clearfix margin"></div>
                    <div class="col-lg-1 col-md-2 col-sm-3 col-xs-6">
                      <a target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${line.sku.split('-')[0]}.html`" >
                        <img class="img-preview" :src="line.image_url === null ? '/static/img/no-image-100x100.jpg' : line.image_url">
                      </a>
                    </div>
                    <div class="clearfix mb-10 visible-sm visible-xs"></div>
                    <div class="col-lg-4 col-md-10 col-sm-12 col-xs-12">
                      <strong>{{line.title}}</strong><br>
                      <small>{{'item_nr' | translate}}: <span class="special">{{line.wws_id}}</span>
                        <br>EAN: <span class="special">{{line.ean}}</span>
                        <br>{{'size' | translate}}: <span class="special">{{line.wws_size}}</span>
                        <br>{{'color' | translate}}: <span class="special">{{line.wws_color}}</span>
                      </small>
                    </div>
                    <div class="clearfix mb-10 visible-md visible-xs"></div>
                    <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                      <strong>{{'item_price' | translate}}: </strong><span :class="[parseFloat(line.item_price) >= parseFloat(line.original_item_price) ? 'text-success' : 'text-danger']">{{line.item_price | currency}}</span><br>
                      <strong>Original-{{'price' | translate}}: </strong><span>{{line.original_item_price | currency}}</span><br>
                      <template v-if="order.customer && order.customer !== null">
                        <strong>MwSt.: </strong>{{`${line.tax_value} %`}}<br>
                      </template>
                      <strong>{{'shipping' | translate}}: </strong>{{line.shipping_price | currency}}
                    </div>
                    <div class="clearfix mb-10 visible-xs"></div>
                    <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                      <template v-if="line.reductions && line.reductions.length > 0">
                        <strong><i class="fa fa-warning mr-5 text-additional"></i>{{'price_reduction' | translate}}:</strong>
                        <ul class="text-additional small list-unstyled">
                          <li v-for="r in line.reductions">{{'refund_amount' | translate}}: - {{r.refund_amount | currency}}</li>
                          <li><strong>{{'amount' | translate}}: </strong>{{line.refundable_amount | currency}}</li>
                        </ul>
                      </template>
                    </div>
                    <div class="clearfix mb-10 visible-xs"></div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                      <strong><i class="fa fa-schuhe mr-5"></i>SKU: </strong><a class="underline text-primary" target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${line.sku.split('-')[0]}.html`" >{{line.sku}}</a><br>
                      <template v-if="order.sales_channel === 'schuhede-zalando'">
                        <strong><i class="fa fa-zalando mr-5"></i>SKU: </strong><a class="underline text-primary" target="_blank" :href="`http://www.zalando.de/kinder/?q=${getZalandoCode(line.mp_item_id)}`">{{getZalandoCode(line.mp_item_id)}}</a><br />
                      </template>
                      <template v-if="order.sales_channel === 'schuhede-amazon' && line.mp_item_id_addition !== ''">
                        <strong><i class="fa fa-amazon mr-5"></i>SKU: </strong><a class="underline text-primary" target="_blank" :href="`https://www.amazon.de/schuhe/dp/${line.mp_item_id_addition}`">{{line.mp_item_id_addition}}</a><br />
                      </template>
                      <strong>{{'qb_line_id' | translate}}: </strong>{{line.id}}
                    </div>
                    <div class="clearfix mb-10"></div>
                    <div class="col-xs-12">
                      <div class="box-controls">
                        <div class="row">
                          <div class="col-lg-4 col-md-5 col-xs-12">
                            <div class="btn-group no-padding btn-sm">
                              <button :disabled="getLabelTransitions(order.shippings, line.shipping_id).length === 0" type="button" data-toggle="modal" data-target="#label-history" class="btn btn-sm btn-default" @click="prepareLabelHistory(line)"><i class="fa fa-truck mr-5"></i>{{'label_history' | translate}}</button>
                              <button type="button" data-toggle="modal" data-target="#historyModal" class="btn btn-sm btn-default" @click="() => {selectedLine = line}"><i class="fa fa-clock-o mr-5"></i>{{'item_history' | translate}}</button>
                              <div class="input-group-btn">
                                <button type="button" data-toggle="modal" data-target="#orderHistoryWithComments" aria-expanded="false" aria-controls="coll1" @click="prepareLineTransitions(line.transitions) " class="btn btn-sm btn-default"><i class="fa fa-star mr-5"></i>{{'store_ranking' | translate}}</button>
                                <button :disabled="checkDisabled(line.status_transitions)" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{'options' | translate}}<span class="fa fa-caret-down ml-5"></span></button>
                                <ul class="dropdown-menu">
                                  <li v-if="line.status_transitions.returnable"><a class="text-warning" @click.prevent="openReturnModal(line.id)" href="#" data-toggle="modal" data-target="#return-modal"><i class="fa fa-reply"></i> {{'return' | translate}}</a></li>
                                  <li v-if="line.status_transitions.cancelable"><a class="text-danger"  @click.prevent="openCancelModal(line.id, line.id)" href="#" data-toggle="modal" data-target="#cancel-modal"><i class="fa fa-ban"></i>{{'cancel_order' | translate}}</a></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-8 col-md-7 col-xs-12">
                            <span v-if="order.status.label === 'mp_cancellation_status'" class="btn-sm text-primary"><strong>{{'reason_for_cancel' | translate}}: {{'mp_cancelled_reason' | translate}}</strong></span>
                            <span v-else-if="line.shipping_id > 0 && line.return_id === 0" class="btn-sm text-success"><strong>{{'sender' | translate}}: {{`${filterStore(line.store_id).name} - ${filterStore(line.store_id).street} ${filterStore(line.store_id).street_no} - ${filterStore(line.store_id).zip_code} ${filterStore(line.store_id).city}`}}</strong></span>
                            <template v-else-if="line.cancellation_id === 0 && line.return_id === 0">
                              <div class="input-group input-sm no-padding">
                                <span class="input-group-addon"><i class="fa fa-truck fa-flip-horizontal mr-5"></i>{{'sender' | translate}}</span>
                                <select class="form-control input-sm" v-model="line.new_store_id" @change="() => {changingStore = true; updateStore(line.id)}">
                                  <option v-for="store in $store.getters.stores" :value="store.id" class="normal">{{store.name}} - {{store.street}} {{store.street_no}}, {{store.zip_code}} {{store.city}}</option>
                                </select>
                              </div>
                              <div v-if="line.storeError">
                                <span class="text-danger">{{'error_updating_store' | translate}}</span>
                              </div>
                              <div v-if="line.is_oversize" class="pt-10">
                                <button class="btn btn-lg btn-success" @click="createOversizeLabel(line.id, line.new_store_id)"><i class="fa fa-print mr-5"></i>Sperrgut Versandpapiere erstellen</button>
                              </div>
                            </template>
                            <template v-else-if="line && order.return_service_id === null && line.return_id > 0">
                              <span class="btn-sm text-success"><strong>{{'sender' | translate}}: {{`${filterStore(line.store_id).name} - ${filterStore(line.store_id).street} ${filterStore(line.store_id).street_no} - ${filterStore(line.store_id).zip_code} ${filterStore(line.store_id).city}`}}</strong></span>
                              <span class="btn-sm text-warning"><strong>{{'reason_for_return' | translate}}: {{getReason(line.return_id, order.returns).reason  | translate}}</strong></span>
                            </template>
                            <span v-else-if="line && line.cancellation_id" class="btn-sm text-danger"><strong>{{'reason_for_cancel' | translate}}: {{getReason(line.cancellation_id, order.cancellations).reason  | translate}}</strong></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr v-if="order.lines.length > 1 && index !== order.lines.length -1">
              </template>
            </div>
            <div class="box-footer">
              <div class="row" style="margin-bottom:30px;">
                <div class="col-md-6 col-sm-6 col-xs-12" v-if="show">
                  <div class="form-group">
                    <label>
                      <div v-if="$store.getters.roles.co_admin || $store.getters.roles.co_orders_send" class="label label-info mr-5"><i class="fa fa-thumbs-up mr-5"></i>{{'ready_to_ship' | translate}}</div>
                      {{'parcel_options' | translate}}
                    </label>
                    <select class="form-control mt-10" v-model="parcel">
                      <option class="normal" v-for="opt in parcelOptions" :value="opt.id">{{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12" v-if="isAmazonPrimeMerchantOrder">
                  <div class="form-group">
                    <label>{{'prime_options' | translate}}</label>
                    <div class="mt-10">
                      <button class="btn btn-warning btn-block" @click="getShippingServices(parcel)">
                        <span>Amazon Prime Versanddienstleister abfragen</span>
                      </button>
                      <select class="form-control mt-10" v-model="shippingService">
                        <option class="normal" v-for="service in shippingServices" :value="service.shipping_service_id">{{service.shipping_service_name}} ({{service.price}} {{service.currency}})</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="clearfix margin"></div>
                <template v-if="shippings && shippings.length > 0 && !showErrorButton">
                  <div class="col-xs-12">
                    <template v-for="(parcel, index) in shippings">
                      <div class="alert alert-warning mb-20" v-if="checkIfAustria(parcel.id)">
                        <div class="row">
                          <div class="col-xs-12">
                            <h3 class="no-margin">Wichtige Informationen zur Bestellung:</h3>
                            <div class="pt-10">Melden Sie sich bitte mit Ihren Zugangsdaten im DPD Business Portal unter <strong><a href="https://www.dpd-business.at/main.php?dmode=1" target="_blank">www.dpd-business.at</a></strong> an und erstellen Sie einen Abholauftrag.</div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <label>{{'tracking' | translate}}:</label><br>
                          <template v-for="label in parcel.labels">
                            <div class="btn-group">
                              <a type="button" :href="label.tracking_url" target="_blank" class="btn btn-default">
                                <i class="fa fa-qrcode mr-5"></i>{{label.type === 'shipping' ? 'order_tracking' : 'return_tracking' | translate}}
                              </a>
                            </div>
                          </template>
                          <div class="margin"></div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <div class="pull-right">
                            <label>{{'parcel' | translate}} {{index + 1}} - {{'documents' | translate}}:</label><br>
                            <div class="btn-group">
                              <a type="button" :href="parcel.combined_path_documents" class="btn btn-success btn-lg" target="_blank"><i class="fa fa-print mr-5"></i>{{'combined_documents' | translate}}</a>
                              <a type="button" :href="parcel.combined_path_shipping" class="btn btn-success btn-lg" target="_blank"><i class="fa fa-print mr-5"></i>{{'combined_shipping' | translate}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr v-if="shippings.length > 1 && index !== (shippings.length -1)"/>
                    </template>
                  </div>
                </template>
                <div class="col-md-12 col-sm-6 col-xs-12 text-right" v-else-if="show">
                  <button onclick="this.disabled = true" @click="createLabels()" :disabled="changingStore || !$store.getters.roles.co_admin && !$store.getters.roles.co_orders_send || shippingService === '' && isAmazonPrimeMerchantOrder || shippingLock" class="btn btn-lg btn-success"><i class="fa fa-print mr-5"></i>{{'create_documents' | translate}}</button>
                  <div v-if="$store.getters.roles.co_admin || $store.getters.roles.co_orders_send" class="alert alert-info pull-left"><i class="fa fa-thumbs-up mr-5"></i>{{'ready_to_ship' | translate}}</div>
                  <div v-else class="pull-left alert alert-warning"><i class="fa fa-warning mr-5"></i>{{'no_permission_to_ship' | translate}}</div>
                </div>
                <div class="text-center alert alert-warning" v-if="showErrorButton">
                  <span v-if="order.own_label_error == true">
                    {{'own_label_error_message_first' | translate}}
                    <p>
                      {{'own_label_error_message_second' | translate}}
                    </p>
                  </span>
                  <span v-else>
                    {{'error_label_address_message' | translate}}
                    <p>
                      {{'error_label_contact_us' | translate}}
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <order-notes :id="$route.params.id"></order-notes>
        </div>
      </div>
      <div class="overlay" v-show="loading">
        <img class="loading-gif" src="/static/img/blabla.svg"/>
      </div>
      <div class="modal fade in" id="createInvoice" tabindex="-1" role="dialog" aria-labelledby="createInvoice_ModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
              <h4 class="modal-title" id="forgot_ModalLabel">Rechnung erstellen</h4>
            </div>
            <div class="modal-body">
              <template v-if="order.customer">
                <div class="row">
                  <div class="col-sm-7 col-xs-12">
                    <h5>{{order.customer.corrected_first_name !== ''? order.customer.corrected_first_name : order.customer.delivery_first_name}} {{order.customer.corrected_last_name !== ''? order.customer.corrected_last_name : order.customer.delivery_last_name}}</h5>
                    <p v-if="order.customer.corrected_street === ''">{{order.customer.delivery_address_line_1}}<br>
                      <!-- <span v-html="this.getObjectData(order.customer.delivery_address_line_2)"></span> !-->
                      <br>{{order.customer.delivery_zip_code}} {{order.customer.delivery_city}}<br>{{order.customer.delivery_country | country}}
                    </p>
                    <p v-else>
                      {{order.customer.corrected_street}} {{order.customer.corrected_street_number}} <br>
                      {{order.customer.corrected_zip}} {{order.customer.corrected_city}}
                    </p>
                  </div>
                  <div class="col-sm-5 col-xs-12">
                    <h5 class="text-warning"><i class="fa fa-warning mr-5"></i>Achtung</h5>
                    <p class="text-warning small">Bitte achten Sie bei der Rechnungserzeugung auf eine korrekte Eingabe.</p>
                  </div>
                  <div class="col-xs-12">
                    <hr>
                    <div class="form-group">
                      <label for="company">Rechnungsnummer <sup>*</sup></label>
                      <input class="form-control" id="invoiceNumber" placeholder="Rechnungsnummer" type="text" v-model="invoiceNumber">
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label for="company">Firma</label>
                      <input class="form-control" id="invoiceCompany" placeholder="Firma" type="text" :value="order.customer.billing_address_line_2">
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label for="customers_name">Name <sup>*</sup></label>
                      <input class="form-control" id="invoiceName" placeholder="Name" type="text" :value="billingName">
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label for="street">Strasse + Hausnummer <sup>*</sup></label>
                      <input class="form-control" id="street" placeholder="Strasse + Hausnummer" type="text" :value="order.customer.billing_address_line_1">
                    </div>
                  </div>
                  <div class="col-sm-4 col-xs-12">
                    <div class="form-group">
                      <label for="zip_code">PLZ <sup>*</sup></label>
                      <input class="form-control" id="zip_code" placeholder="PLZ" type="text" :value="order.customer.billing_zip_code">
                    </div>
                  </div>
                  <div class="col-sm-8 col-xs-12">
                    <div class="form-group">
                      <label for="city">Ort <sup>*</sup></label>
                      <input class="form-control" id="city" placeholder="Ort" type="text" :value="order.customer.billing_city">
                    </div>
                  </div>
                  <div class="col-sm-12 col-xs-12">
                    <div class="form-group">
                      <label for="country">Land</label>
                      <select class="form-control disabled">
                        <option selected>{{order.customer.billing_country}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-app btn-outline no-margin pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate}}</button>
              <button class="btn btn-app btn-success" @click="createInvoice()" ><i class="fa fa-save"></i>{{'create_documents' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import OrderHistory from '../tools/OrderHistory.vue'
import LabelHistory from '../tools/LabelHistory.vue'
import OrderHistoryWithComments from '../tools/orderHistoryWithComments.vue'
export default {
  data () {
    return {
      storeId: 0,
      lineId: 0,
      erpBarcode: '',
      selectedShipping: {},
      orderKey: 0,
      selectedReturn: {},
      selectedLabelTransitions: {},
      goto: '',
      erpDisabled: false,
      erpDisabledBtn: false,
      sent: false,
      notFound: false,
      showErrorButton: false,
      shipStatus: '',
      shippings: {},
      shippingLock: {},
      selectedLine: {},
      cancellations: {},
      counter: 0,
      formstate: {},
      show: false,
      invoiceForm: {},
      streetName: '',
      loading: false,
      streetNumber: '',
      parcel: this.$store.getters.parcelId,
      lineForCancel: 0,
      lineForReturn: 0,
      lineTransitions: {},
      itemForCancel: 0,
      changingStore: false,
      storeError: false,
      billingName: '',
      order: {
        billing_address_addition: '',
        billing_city: '',
        billing_country: '',
        billing_first_name: '',
        billing_last_name: '',
        billing_zip_code: '',
        billing_address_line_1: '',
        billing_address_line_2: '',
        billing_address_line_3: '',
        company_id: '',
        created_at: '',
        currency: '',
        customer_email: '',
        customer_id: '',
        customer_phone_number: '',
        delivery_address: '',
        delivery_address_addition: '',
        delivery_city: '',
        delivery_country: '',
        delivery_first_name: '',
        delivery_last_name: '',
        delivery_zip_code: '',
        ext_order_id: '',
        id: '',
        sales_channel: 'schuhede',
        invoice_city: '',
        invoice_company: '',
        invoice_country: '',
        invoice_name: '',
        invoice_street: '',
        invoice_street_no: '',
        invoice_zip_code: '',
        lines: [],
        label_care_of: '',
        label_city: '',
        label_company: '',
        label_country: '',
        label_name: '',
        label_street: '',
        label_street_no: '',
        label_zip_code: '',
        merchant_external_order: '',
        number_of_lines: '',
        order_date: '',
        order_total: '',
        order_type: '',
        payment_method: '',
        sales_channel_id: '',
        shipping_city: '',
        shipping_country: '',
        shipping_name: '',
        shipping_street: '',
        shipping_street_no: '',
        shipping_zip_code: '',
        status: {},
        items: {}
      },
      editAddress: {
        corrected_company: '',
        corrected_first_name: '',
        corrected_last_name: '',
        corrected_zip: '',
        corrected_city: '',
        corrected_street: '',
        corrected_street_number: '',
        corrected_care_of: ''
      },
      validDeliveryCountries: ['DE', 'AT', 'FR', 'NL', 'UK', 'BE', 'ES', 'IT'],
      retryId: 0,
      invoiceNumber: '',
      invoicePath: '',
      isDirectListing: 0,
      parcelOptions: [],
      shippingServices: [],
      shippingService: '',
      alerts: [],
      error: {},
      pepe () {
        this.updateOrder()
      },
      checkDefaultFields () {
        let shippingLabel = {
          label_name: this.order.label_name,
          label_care_of: this.order.label_care_of,
          label_street: this.order.label_street,
          label_street_no: this.order.label_street_no,
          label_city: this.order.label_city,
          label_zip_code: this.order.label_zip_code
        }
        let billingLabel = {
          invoice_name: this.order.invoice_name,
          invoice_care_of: this.order.invoice_care_of,
          invoice_street: this.order.invoice_street,
          invoice_street_no: this.order.invoice_street_no,
          invoice_city: this.order.invoice_city,
          invoice_zip_code: this.order.invoice_zip_code
        }
        let alertMsg = 'There is a problem in the billing address format. Please edit the address manually to proceed the order.'
        let alert = {type: 'danger', message: alertMsg}
        for (let x in shippingLabel) {
          if (shippingLabel[x] === '') {
            if (x === 'label_care_of' && (shippingLabel.label_street === 'PACKSTATION' || shippingLabel.label_street === 'POSTFILIALE')) {
              this.$store.commit('pushAlert', alert)
            } else if (x !== 'label_care_of') {
              this.$store.commit('pushAlert', alert)
            }
          }
        }
        for (let y in billingLabel) {
          if (billingLabel[y] === '') {
            if (y === 'invoice_care_of' && (billingLabel.invoice_street === 'PACKSTATION' || billingLabel.invoice_street === 'POSTFILIALE')) {
              this.$store.commit('pushAlert', alert)
            } else if (y !== 'label_care_of') {
              this.$store.commit('pushAlert', alert)
            }
          }
        }
      }
    }
  },
  computed: {
    isAmazonPrimeMerchantOrder () {
      // Order data wasn't received from backend, yet
      if (this.order.merchant_external_order === '') {
        return false
      }

      return this.order.order_type.toLowerCase() === 'amazon_prime' && this.order.merchant_external_order !== 0
    }
  },
  components: {
    orderHistory: OrderHistory,
    labelHistory: LabelHistory,
    orderHistoryWithComments: OrderHistoryWithComments
  },
  methods: {
    getObjectData (stringdata) {
      let output = ''
      let parsedData = ''
      try {
        parsedData = JSON.parse(stringdata)
      } catch (e) {}
      if (typeof parsedData === 'string' || parsedData instanceof String) {
        return parsedData
      }
      for(let prop in parsedData) {
        output += parsedData[prop]+"<br />"
      }
      return output
    },
    prepareLabelHistory (item) {
      this.selectedLabelTransitions = this.order.shippings.filter(e => e.id === item.shipping_id)[0].labels
      this.selectedShipping = this.getShipping(item.shipping_id, 'shipping')
      this.selectedReturn = this.getShipping(item.shipping_id, 'return')
    },
    getLabelTransitions (shippings, id) {
      let ret = []
      shippings.forEach(s => {
        if (s.id === id) {
          s.labels.forEach(l => {
            ret.push({type: l.type, transitions: l.transitions})
          })
        }
      })
      return ret
    },
    prepareLineTransitions (lineTransitions) {
      this.lineTransitions = lineTransitions
    },
    getZalandoCode (url) {
      let aux = url.split('-')
      return `${aux[0]}-${aux[1].substr(0, 3)}`
    },
    getIcon (mp) {
      return mp === 'schuhede' ? 'fa fa-schuhe' : mp.split('_')[0] === 'merchant' ? `fa fa-qualibet` : `fa fa-${mp.split('-')[1]}`
    },
    getShipping (id, type) {
      for (let p in this.shippings) {
        if (this.shippings[p].id === id) {
          for (let l in this.shippings[p].labels) {
            if (this.shippings[p].labels[l].type === type) {
              return this.shippings[p].labels[l].tracking_url
            }
          }
        }
      }
    },
    getShippingServices (parcelId) {
      API.put(`/orders/${this.order.id}/eligibleShippingServices`, {'parcel_id': parcelId})
        .then(response => {
          this.shippingServices = response.data.services
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.$store.commit('pushAlert', alert)
        })
    },
    checkIfAustria (shipping) {
      return this.order.delivery_country === 'AT'
      /*let line = this.order.lines.find(l => {
        return l.shipping_id === shipping
      })
      let store = this.$store.getters.stores.find(s => {
        return s.id === line.booked_store_id
      }) || {name: 'zugeordnete Filiale wurde nicht gefunden', street: '', street_no: '', city: '', zip_code: ''}
      return store.shipping_country === 'AT'*/
    },
    sendRefund (data) {
      API.put(`/orders/line/${this.lineForRefund}/case`, data)
        .then(response => {
          let alert = {type: 'success', dismiss: 4, message: 'Case created successfully'}
          this.updateOrder()
          this.$store.commit('pushAlert', alert)
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.$store.commit('pushAlert', alert)
        })
    },
    erpExport () {
      this.erpDisabledBtn = true
      API.get(`/orders/${this.order.id}/export`)
        .then(response => {
          let alert = {type: 'success', dismiss: 4, message: response.data.message}
          this.$store.commit('pushAlert', alert)
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: ['E-rror']}
          this.$store.commit('pushAlert', alert)
        })
    },
    cancelOrder (value) {
      API.put(`/orders/line/${this.lineForCancel}/cancel`, value)
        .then(response => {
          $('#closeCancelModal').click()
          $('#bcd').attr('disabled', false)
          this.updateOrder()
        }, error => {
          $('#closeCancelModal').click()
          $('#bcd').attr('disabled', false)
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.updateOrder()
          this.$store.commit('pushAlert', alert)
        })
    },
    goToMp () {
      API.get(`/orders?ext_order_id=${this.gotoMP}`)
        .then(response => {
          if (response.data.data.length > 1 || response.data.data.length === 0) {
            this.$router.push('/orders/error')
          } else {
            this.$router.push(`/orders/${response.data.data[0].id}`)
          }
        })
    },
    checkLabelsCall () {
      API.get(`orders/${this.$route.params.id}/shippings/check`)
        .then(response => {
          this.shipStatus = response.data.status
          if (response.data.status === 'done' || response.data.status === 'error') {
            this.loading = false
            if (response.data.status === 'error') {
              this.show = false

              this.showErrorButton = true
              this.getCustomer()
              this.updateOrder(true)
            } else {
              this.updateOrder()
            }
          } else {
            setTimeout(this.checkLabelsCall, 5000)
          }
        }, error => {
          this.loading = false
          this.showErrorButton = true
        })
    },
    checkShippingError (data) {
      let ret = false
      data.forEach(d => {
        if (d.combined_path_shipping === '' || d.combined_path_documents === '') {
          ret = true
        }
      })
      return ret
    },
    createOversizeLabel(lineId, storeId) {
      API.put(`orders/${this.$route.params.id}/ship/oversize`, {store_id: storeId, line_id: lineId})
        .then(response => {
          this.sent = true
          this.loading = true
          this.checkLabelsCall()
        }, error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.$store.commit('pushAlert', alert)
        })
    },
    createLabels () {
      if (this.isAmazonPrimeMerchantOrder) {
        API.post(`/orders/${this.order.id}/savePrimeShippingService`, {'shipping_service_id': this.shippingService})
          .then(response => {
            let alert = {type: 'success', dismiss: 4, message: 'Auswahl gespeichert'}
            this.$store.commit('pushAlert', alert)
          })
          .catch(error => {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.$store.commit('pushAlert', alert)
          })
      }
      API.put(`orders/${this.$route.params.id}/ship`, {parcel_id: this.parcel})
        .then(response => {
          this.sent = true
          this.loading = true
          this.checkLabelsCall()
        }, error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.$store.commit('pushAlert', alert)
        })
    },
    checkDisabled (line) {
      let a = Object.keys(line).find(e => {
        return line[e] === true
      })
      return typeof a === 'undefined'
    },
    filterStore (id) {
      let stores = this.$store.getters.stores
      return stores.find(s => {return s.id === id}) || {name: 'zugeordnete Filiale wurde nicht gefunden', street: '', street_no: '', city: '', zip_code: ''}
    },
    getCancellation (id) {
      let c = this.order.cancellations
      for (let x in c) {
        if (c[x].id === id) {
          return c[x]
        }
      }
    },
    getReason (needle, haystack) {
      for (let x in haystack) {
        if (haystack[x].id === needle) {
          return haystack[x]
        }
      }
    },
    infoLabels (parcel) {
      return parcel.return_information_path !== '' && parcel.delivery_information_path !== '' && parcel.combined_path !== ''
    },
    getStatus (item) {
      if (item.transitions.length > 0) {
        let status = item.transitions[item.transitions.length - 1].transition
        if (status === 'mp_cancellation') {
          return {label: 'mp_cancellation_status', style: 'label label-primary', icon: 'fa fa-exclamation-triangle mr-5'}
        }
        if (status === 'initial') {
          return {label: 'reserved', style: 'label label-primary', icon: 'fa fa-bookmark mr-5'}
        }
        if (status === 'canceled' || status === 'cancelled') {
          return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
        }
        if (!item.return_service_id && status === 'returned') {
          return {label: 'returned_status', style: 'label label-warning', icon: 'fa fa-reply mr-5'}
        }
        if (status === 'shipped' || status === 'fulfilled') {
          return {label: 'shipped', style: 'label label-success', icon: 'fa fa-check mr-5'}
        }
        if (status === 'open' || status === 'approved') {
          return {label: 'open', style: 'label label-info', icon: 'fa fa-sign-in mr-5'}
        }
      } else {
        return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
      }
    },
    getLineStatus (line, returnServiceId = null) {
      let label = {label: 'open', style: 'label label-info', icon: 'fa fa-sign-in mr-5'};
      if (line.cancellation_id > 0) {
        label = {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
      } else if (!returnServiceId && line.return_id > 0) {
        label = {label: 'returned_status', style: 'label label-warning', icon: 'fa fa-reply mr-5'}
        if (Object.keys(line.cases).length > 0) {
          label = {label: 'return_with_goodwill_discount_label', style: 'label label-warning', icon: 'fa fa-money mr-5'}
        }
      } else if (Object.keys(line.cases).length > 0) {
        label = {label: 'goodwill_discount_label', style: 'label label-additional', icon: 'fa fa-money mr-5'}
      } else if (line.shipping_id > 0) {
        label = {label: 'shipped', style: 'label label-success', icon: 'fa fa-check mr-5'}
      }
      return label;
    },
    openCancelModal (item, line) {
      this.itemForCancel = item
      this.lineForCancel = line
    },
    openReturnModal (line) {
      this.lineForReturn = line
    },
    openRefundModal (line) {
      this.lineForRefund = line
    },
    sendReturn (value) {
      API.put(`/orders/line/${this.lineForReturn}/return`, {status: value[0], reason: value[1]})
        .then(response => {
          $('#closeReturnModal').click()
          $('#abc').attr('disabled', false)
          this.updateOrder()
        })
        .catch(error => {
          $('#closeReturnModal').click()
          let message = [error.response.data.message]
          $('#abc').attr('disabled', false)
          if (error.response.status === 502) {
            message = ['Achtung! Es ist nicht zulässig, Artikel, die nicht ausgeliefert werden können, erst zu bestätigen und anschließend zu retournieren.\n' +
            'Bitte setzen Sie sich mit unserem Customer Service unter service@schuhe.de oder +49 6182 9282274 in Verbindung, um die weitere Vorgehensweise zu besprechen.']
          }
          let alert = {type: 'danger', dismiss: 4, message: message}
          this.$store.commit('pushAlert', alert)
        })
    },
    getCustomer () {
      API.get(`orders/${this.$route.params.id}`)
        .then(response => {
          this.order.customer = response.data.customer
          this.editAddress = response.data.customer
        }, error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.$store.commit('pushAlert', alert)
        })
    },
    alertError (value) {
      $('#closeRefundModal').click()
      this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: [value], icon: 'icon fa fa-ban', show: true})
    },
    alert (value) {
      let alert
      this.checkLabelsCall()
      if (value.status === 200 || value.status === 204 || value.status === 202) {
        alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
      } else if (value.status === 0) {
        alert = {dismiss: 4, type: 'warning', message: 'Not modified', icon: 'icon fa fa-warning', show: true}
      } else {
        alert = {dismiss: 4, type: 'danger', message: `There was an error: ${value.data.message}`, icon: 'icon fa fa-ban', show: true}
      }
      this.$store.commit('pushAlert', alert)
    },
    updateOrder (labelError = false) {
      if (!labelError) {
        this.alerts = []
        this.showErrorButton = false
      }
      this.show = false
      this.retryId = 0
      this.itemForCancel = 0
      this.lineForCancel = 0
      this.cancelReason = 'out_of_stock'
      API.get(`/orders/${this.$route.params.id}`)
        .then(response => {
          this.order = response.data
          this.order.status = this.getStatus(this.order)
          if (this.order.customer) {
            this.billingName = this.order.customer.billing_first_name + ' ' + this.order.customer.billing_last_name
          }
          let main = []
          this.order.transitions.forEach(t => {
            let date = t.date.split(' ')
            if (!(date[0] in main)) {
              main[date[0]] = {date: date[0], transitions: []}
            }
            main[date[0]].transitions.push({event: `${t.transition}_tr`, time: date[1]})
          })
          this.order.transitions = []
          for (let k in main) {
            this.order.transitions.push(main[k])
          }
          this.order.lines.forEach(y => {
            y.new_store_id = y.store_id
            y.storeError = false
            let aux = []
            if (this.order.status.label === 'open' || this.order.status.label === 'shipped') {
              y.status = this.getLineStatus(y, this.order.return_service_id)
            } else {
              if (this.order.status.label === 'mp_cancellation_status') {
                y.status = {label: 'mp_cancellation', style: 'label label-primary', icon: 'fa fa-exclamation-triangle mr-5'}
              } else {
                y.status = this.order.status
              }
            }
            if (y.shipping_id === 0 && y.cancellation_id === 0 && this.order.status.label !== 'reserved') {
              this.show = true
            }
            if (y.transitions.length > 0) {
              y.transitions.forEach(t => {
                let date = t.date.split(' ')
                if (!(date[0] in aux)) {
                  aux[date[0]] = {date: date[0], transitions: []}
                }
                aux[date[0]].transitions.push({event: `${t.transition}_ln`, time: date[1], points: t.points,message: t.message})
              })
              y.transitions = []
              for (let a in aux) {
                y.transitions.push(aux[a])
              }
            }
          })
          if (this.order.status.label === 'initial' || this.order.status.label === 'mp_cancellation_status' || this.order.status.label === 'shipped') {
            this.show = false
          }
          this.shippingLock = this.order.shippingLock
          this.shippings = this.order.shippings
          if (this.checkShippingError(this.shippings)) {
            if (!labelError) {
              this.checkLabelsCall()
            }
          }
          this.checkDefaultFields()

          let directListingChannels = ['merchant_order_amazon']
          if (directListingChannels.includes(this.order.sales_channel)) {
            this.isDirectListing = 1
            this.getInvoice()
          }

          API.get(`/orders/parcel-options/${this.order.id}`)
            .then(response => {
              this.parcelOptions = response.data
            })
            .catch(error => {
              this.notFound = error.response.status === 404
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              if (error.response.status !== 404) {
                this.$store.commit('pushAlert', alert)
              }
            })

        })
        .catch(error => {
          this.notFound = error.response.status === 404
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          if (error.response.status !== 404) {
            this.$store.commit('pushAlert', alert)
          }
        })
    },
    createInvoice () {
      if (this.invoiceNumber !== '') {
        API.post(`directsales/invoice/${this.$route.params.id}`, {invoice_number: this.invoiceNumber})
          .then(res => {
            let alert = {type: 'success', dismiss: 4, message: ['Rechnung wird erstellt']}
            this.$store.commit('pushAlert', alert)
          })
      }
    },
    getInvoice () {
      API.get(`directsales/invoice/${this.$route.params.id}`)
        .then(response => {
          this.invoicePath = response.data.url
        }, error => {
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
          this.$store.commit('pushAlert', alert)
        })
    },
    updateStore (id) {
      let line = this.order.lines.find(x => {
        return x.id === id
      })
      line.storeError = false
      API.put(`/orders/line/${line.id}/store`, {store_id: line.new_store_id})
        .then(res => {
          this.changingStore = false
          this.orderKey++
        })
        .catch(error => {
          line.new_store_id = line.store_id
          this.changingStore = false
          line.storeError = true
          line = [...line]
          this.orderKey++
        })
    },
    checkErpDisabled () {
      if (this.$store.getters.user.erp_system_name.includes('etos')) {
        this.erpDisabled = true
      }
    }
  },
  mounted () {
    if (this.$store.dispatch('checkPermissions', 'co_accounting')) {
      this.updateOrder()
      this.checkErpDisabled()
    }
  },
  watch: {
    '$route.params.id' () {
      this.notFound = false
      this.updateOrder()
    },
    order () {}
  }
}
</script>
<style>
.special {
  font-size: 0.975rem;
  font-weight: bold;
}
.overlay {
  z-index: 50;
  background: rgba(33,34,40,.75);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
}
.overlay-text{
  position: absolute;
  top: 54%;
  left: 49%;
  margin-left: -1rem;
  margin-top: -1rem;
}
.overlay > .fa {
  position: absolute;
  top: 50%;
  left: 57%;
  margin-left: -1rem;
  margin-top: -1rem;
  color: currentColor;
  font-size: 2rem;
  opacity: 0.65;
}
select option.danger {
  margin: 40px;
  background:rgb(86, 32, 27);
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
select option.normal {
  margin: 40px;
  background:rgb(32, 34, 39);
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
select option.warning {
  margin: 40px;
  background:#5e4219;
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
</style>
<style scoped>
.loading-gif {
  display: block;
  width: 5%;
  top: 42%;
  left: 50%;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/views/SingleOrder.vue